import { EResellerCommissionDurationType } from "../../Enum/EResellerCommissionDurationType"

export class ResellerCommissionPlan {
  id: number

  name: string

  commissionPercentage: number

  durationType: EResellerCommissionDurationType

  durationInMonths?: number

  isActive: boolean

  isDefault: boolean

  constructor(data: Partial<ResellerCommissionPlan> = {}) {
    this.id = data.id ?? 0

    this.name = data.name ?? ""

    this.commissionPercentage = data.commissionPercentage ?? 0

    this.durationType = data.durationType ?? EResellerCommissionDurationType.Recurring

    this.durationInMonths = data.durationInMonths

    this.isActive = data.isActive ?? true

    this.isDefault = data.isDefault ?? false
  }
}
